import script from "./FeeConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./FeeConfiguration.vue?vue&type=script&setup=true&lang=js"

import "./FeeConfiguration.vue?vue&type=style&index=0&id=f8dae69c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8dae69c"]])

export default __exports__